import React, { useEffect, useState } from "react";
import AccordionComponent from "../../../../common/Accordion";
import DataTable from "../../../../common/DataTable";
import { PARTY_NOTIFICATION_PREFERENCE_HEADERS } from "../actions/Constant";
import {
  fetchNotificationCongiguration,
  fetchPartyNotificationCongiguration,
  updatePartyNotificationConfiguration,
} from "../../../../services/NotificationConfigurationAPI";
import { Button, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import Snackbar from "../../../../common/Snackbar";
import PartyNotificationDataTable from "./PartyNotificationDataTable";

const PartyNotificationPreference: React.FC<any> = ({
  stakeholdercontactid,
}) => {
  const [configurationAccordianKey, setConfigurationAccordianKey] = useState<
    string | null
  >(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const userID = useSelector((state: RootState) => state.auth.userid);

  const [configurationData, setConfigurationData] = useState<any[]>([]);
  const [configurationResultData, setConfigurationResultData] = useState<any[]>(
    [],
  );

  const fetchNotificationCongigurationData = async () => {
    setLoading(true);
    try {
      const configuration =
        await fetchPartyNotificationCongiguration(stakeholdercontactid);
      if (configuration) {
        setConfigurationData(configuration);
        setConfigurationResultData(configuration);
      } else {
        console.error("No data found in Notification Configuration result");
      }
    } catch (error) {
      console.error("Error fetching configuration:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchNotificationCongigurationData();
    }, 2000); // 2 seconds delay

    return () => clearTimeout(timer); // cleanup if stakeholdercontactid changes before timeout
  }, [stakeholdercontactid]);

  const handleCheckboxChange = (
    rowId: any,
    key: string,
    forcedValue?: number,
  ) => {
    setConfigurationData((prevData) =>
      prevData.map((item) =>
        item.id === rowId
          ? {
              ...item,
              [key]:
                forcedValue !== undefined
                  ? forcedValue
                  : item[key] === 1
                    ? 0
                    : 1,
            }
          : item,
      ),
    );
  };

  const handleSave = async () => {
    try {
      const changedConfigurations = configurationData.filter((item) => {
        const original = configurationResultData.find((o) => o.id === item.id);

        if (!original) return false; // safety check

        return (
          original.isEmailNotification !== item.isEmailNotification ||
          original.isSmsNotification !== item.isSmsNotification ||
          original.isInAppNotification !== item.isInAppNotification
        );
      });

      const updatePayload = {
        preferences: changedConfigurations.map((item) => ({
          notificationpreferenceid: item.id,
          stakeholderContactId: stakeholdercontactid,
          eventname: item.eventName,
          isemailnotification: item.isEmailNotification,
          issmsnotification: item.isSmsNotification,
          isinappnotification: item.isInAppNotification,
        })),
        triggerById: userID,
      };

      const response =
        await updatePartyNotificationConfiguration(updatePayload);
      const successMessage =
        "Configuration Notifications updated successfully.";
      if (response.isSuccess) {
        setSnackbarMessage(successMessage);
        setError("success");
        setSnackbarOpen(true);

        // ✅ update original data so next comparison works correctly
        setConfigurationResultData(configurationData);
        fetchNotificationCongigurationData();
        setConfigurationAccordianKey(null);
      }
    } catch (error) {
      console.error("Error while saving notification configuration:", error);
      setSnackbarMessage("An unexpected error occurred.");
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const NotificationDetailAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={configurationAccordianKey}
      onSelect={(key) => setConfigurationAccordianKey(key as string)}
    />
  );
  return (
    <>
      <div>
        {NotificationDetailAccordion([
          {
            title: "Notification Preferences",
            content: (
              <>
                <Snackbar
                  open={snackbarOpen}
                  message={snackbarMessage}
                  onClose={() => setSnackbarOpen(false)}
                  severity={error}
                />
                <PartyNotificationDataTable
                  headers={PARTY_NOTIFICATION_PREFERENCE_HEADERS}
                  rows={configurationData}
                  onDownloadAction={handleCheckboxChange}
                />
                <div className="row">
                  <Row className="my-3 mx-0">
                    <Col className="d-flex justify-content-end align-items-end">
                      <Button
                        variant="outline-info"
                        className="d-flex align-items-center"
                        onClick={fetchNotificationCongigurationData}
                      >
                        <span className="material-icons mr-2">close</span>
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="primary"
                        className="ms-3 d-flex align-items-center"
                        onClick={handleSave}
                      >
                        <span className="material-icons mx-1">save</span>
                        Save
                      </Button>
                    </Col>
                  </Row>
                </div>
              </>
            ),
          },
        ])}
      </div>
    </>
  );
};

export default PartyNotificationPreference;
